import { ReactNode } from 'react';

import { PageTitle } from '@/components/PageTitle';
import {
  ALIGN_EVALUATOR_PLAYGROUND_PAGE_TITLE,
  PLAYGROUND_PAGE_DESCRIPTION,
  PLAYGROUND_PAGE_TITLE,
} from '@/constants/pageTitlesAndDescriptionConstants';

import { useAlignEvaluatorInfo } from '../PlaygroundHome/hooks/useAlignEvaluator';

export function PlaygroundHeader(props: {
  rightActions?: ReactNode;
  leftActions?: ReactNode;
}) {
  const { isAlignEvaluatorV2 } = useAlignEvaluatorInfo();
  return (
    <div className="flex w-full items-center space-x-4 px-4">
      <div className="flex-shrink-0">
        <PageTitle
          description={
            isAlignEvaluatorV2 ? undefined : PLAYGROUND_PAGE_DESCRIPTION
          }
        >
          {isAlignEvaluatorV2
            ? ALIGN_EVALUATOR_PLAYGROUND_PAGE_TITLE
            : PLAYGROUND_PAGE_TITLE}
        </PageTitle>
      </div>
      <div className="flex flex-grow justify-between">
        <div className="flex gap-2">{props.leftActions}</div>
        <div className="flex gap-2">{props.rightActions}</div>
      </div>
    </div>
  );
}
